<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Get our special offer for your company needs
                                  
                                </h1>
                                
                                <p class="lead  text-white">We will deliver your software project on time.
                                </p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
  


   
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/why-work-with-smakintel.jpg" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                             <h3> Contact us to get the following:</h3>
                            <p>Utilize highly experienced specialists in desktop, web, and mobile development.
                                Our developers employ the latest technologies, frameworks, and components to 
                                create solutions that combine a strong technical back-end with easy to use modern design</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Price estimation</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">Time to delivery</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">Recommendation on tech stack  </h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                          <img src="@/assets/online-support.png" class="img-fluid floating">  
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <h3 class="head text-white">KEEP IN TOUCH WITH US</h3>
                            
                            <p class="lead  text-white text-justify">Is a consulting company providing services and technology solutions. 
                                We stand beside all businesses to help them shape and drive their transformation journey. 
                                We are always at the forefront of innovation.</p>
                                
                               
                     </div>
                </div>
            </div>
        </section>
        <!--
        <section class="section section-lg pt-0">
            <div class="container">
                
                <card gradient="white"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">

                            <div class="col-md-4 order-lg-2 ml-lg-auto">
                                <p class="lead  "> <i class="fas fa-map-marker"></i> United Kingdom
                                <br>
                                SMAKINTEL SOLUTIONS LTD
                                <br>
                                Kemp House, 160 City Road, 
                                <br>
                                London, EC1V 2NX.
                             
                                </p>
                                <hr class="h_border">
                                <p class="lead  "><i class="fas fa-mobile"></i> +65-97223997</p>
                                <hr class="h_border">
                                <p class="lead "><i class="fas fa-envelope"></i> info@smakintel.com</p>  
                             </div>

                             <div class="col-md-4 order-lg-2 ml-lg-auto">
                                <p class="lead  "> <i class="fas fa-map-marker"></i> Singapore
                                <br>
                                No 28,
                                <br>
                                Riverside Road,
                                <br>
                                Singapore 739085
                             
                                </p>
                                <hr class="h_border">
                                <p class="lead  "><i class="fas fa-mobile"></i> +65-97223997</p>
                                <hr class="h_border">
                                <p class="lead "><i class="fas fa-envelope"></i> info@smakintel.com</p>  
                             </div>
                             <div class="col-md-4 order-lg-2 ml-lg-auto">
                                <p class="lead  "> <i class="fas fa-map-marker"></i> Sri Lanka
                                <br>
                                No 20,
                                <br>
                                2nd Lane Linganagar,
                                <br>
                                Trincomalee,
                                <br>
                                Sri Lanka.</p>
                                <hr class="h_border">
                                <p class="lead  "><i class="fas fa-mobile"></i> +94-26 205 5830</p>
                                <hr class="h_border">
                                <p class="lead "><i class="fas fa-envelope"></i> info@smakintel.com</p>  
                             </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        --->
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="warning"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Start Your Next Project with SMAKINTEL.</h3>
                                <p class="lead text-white mt-3">We will be the leader of a company that ends up being
                                    worth billions of dollars, because We got the solutions. We understand culture.</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="../contact-us"
                                             type="white" block size="lg">
                                    Contact Us
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
       
       

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
<style scoped>
.bg-gradient-warning {
    background: linear-gradient(
87deg
, #39239c 0, #3835e0 100%) !important;
}
hr.h_border{
    border-block-color: rgb(139, 136, 136);
}
</style>
